import React,{useState,useRef,useEffect,useContext} from "react";
import { Raccourci,ArticleBarSearch,ModalSelectionSupplementList,CustomMadeItemBtn,RppslModalEdit,ModalAddTo} from "@gull";
import { useTranslate } from 'react-redux-multilingual'
import useGetNextShortcut from "@gull/hooks/useGetNextShortcut";
import useShortcutNavigation from "@gull/hooks/useShortcutNavigation";
import SweetAlert from "sweetalert2-react";
import axios from 'axios'
import swal from "sweetalert2";
import { IsAuthContext } from 'app/App';
import { Modal } from "react-bootstrap";

const useSearchItem = () => {
    const [loadingSearchItem,setLoadingSearchItem]=useState(false)
    const [generalErrorSearchItem,setGeneralErrorSearchItem]=useState(false)
    const [listSearchItem,setListSearchItem]=useState([])
    const [datas,setDatas] = useState(listSearchItem)
    const searchInput = useRef('')

    const loadItems = async (inputValue) => {
        setLoadingSearchItem(true)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/name/"+inputValue
        ).then((response) => {
            setLoadingSearchItem(false)
            setListSearchItem(response.data.datas)
            let ajour = response.data.datas.filter((value)=>value.name.replace(/\u00A0/g,' ').toLowerCase().includes(searchInput.current.value.replace(/\u00A0/g,' ').toLowerCase()))
            setDatas(ajour)
        }).catch((error) => {
            if(error=='end_session') return;
            setLoadingSearchItem(false)
            setGeneralErrorSearchItem(true)
        }) 
    }

    return [loadingSearchItem,setLoadingSearchItem,loadItems,generalErrorSearchItem,setGeneralErrorSearchItem,listSearchItem,datas,setDatas,searchInput]
}

const BarRight = (props) => {
    const t =useTranslate()
    const [loadingSearchItem,setLoadingSearchItem,loadItems,generalErrorSearchItem,setGeneralErrorSearchItem,listSearchItem,datas,setDatas,searchInput]=useSearchItem()
    const [valueInput,setValueInput]=useState('')
    
    const [disabled,setDisabled]=useState(false)
    const idsLocalStorage=localStorage.getItem("pos").split(',')
    const [allRaccourci,setAllRaccourci]=useState([])
    const raccourciArr = ['article_id','fifthlevelcat_id','firstlevelcat_id','fourthlevelcat_id','secondlevelcat_id','thirdlevelcat_id','marque_id','fournisseur_id']
    const { authParam } = useContext(IsAuthContext);
    const modulePos = authParam.modules.find(value=>value.name=='pos')
    const [negativeAlreadyScan,setNegativeAlreadyScan]=useState([]) 

    // Module mode_service
    const mode_service = modulePos.params?.mode_service?.active

    // Module article sur mesure
    const custom_made_article = modulePos.params?.on_demand?.active

    // Modal d'édition de liste de supplément
    const [showModal,setShowModal]=useState(false) //Pour affichage modal
    const [dataNextList,setDataNextList] = useState([])
    const [lastListClicked,setLastListClicked]=useState([])
    const [editArticleId,setEditArticleId]=useState(false)

    // modal édition RP PSL
    const [showModalEdit,setShowModalEdit]=useState(false)
    const [articleIdModal, setArticleIdModal]=useState(false)
    const [rpValue,setRpValue]=useState(0)
    const [pslValue,setPslValue]=useState(0)
    const [rppslId,setRppslId]=useState(0)
    const [validButton,setValidButton]=useState(false)
    const [rppsl,setRppsl]=useState([])

    // Modal ajout To
    const [showModalAddTo,setShowModalAddTo]=useState(false)
    const [articleNameModal, setArticleNameModal]=useState(false)
    const [articleSkuModal, setArticleSkuModal]=useState(false)

    useEffect(function () { //fonction qui lance et relance le focus sur l'input de recheche d'article
        if(searchInput.current){
            setTimeout(()=>{
                if(searchInput.current){
                    searchInput.current.focus()
                }
            },500)
        }
    }, [props.relanceFocus,searchInput])

    useEffect(function () {
        if(props.section && props.section.profil_raccourci_caisse!=null){
            if(props.section.profil_raccourci_caisse.raccourci_caisse_detail.length!=0){  
                //on réorganise l'ordre d'affichage des raccourcis selon la varibale position
                let bonOrdre = props.section.profil_raccourci_caisse.raccourci_caisse_detail.sort((a, b) => (a.position > b.position ? 1 : -1))
                setAllRaccourci(bonOrdre)
            }
        }
        
    }, [props.section])

    const handleSubmitCheckSupplement = async (e,articleid) => {
        let data  
        if(articleid){//Si on recherche l'article à la main
            data = { 
                article_id:articleid
            }
        }else{//si on scan un article
            data = { 
                reference:valueInput
            }
        }
        if (modulePos.params?.article?.params?.supplement_list) {
            const response = await axios.post(process.env.REACT_APP_API_URL+"api/erp/supplement_list/get_article_supplement_list_pos",data
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }
                else{
                    if (Object.keys(response.data.data.supplement_list).length > 0) {
                        setDataNextList(response.data.data)
                        setEditArticleId(response.data.data.id)
                        setShowModal(response.data.data.id)
                    }
                    else {
                        handleSubmit(e,articleid)
                    }
                }
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
        }
        else handleSubmit(e,articleid)
    }

    const handleSubmit = async (e,articleid) =>{
        if(e) e.preventDefault();
        setLoadingSearchItem(true)
        props.setDisabledPay(true)
        props.setDisabledCloudButton(true)
        
        let data  
        if(articleid){//Si on recherche l'article à la main
            data = { 
                article_id:articleid
            }
        }else{//si on scan un article
            data = { 
                reference:valueInput
            }
        }
        
        if(props.cookies.current_ticket){
            data['id']=props.cookies.current_ticket

        }else{
            if(props.cashierId){
                data['rh_id']=props.cashierId
            }
            if(props.clientId){
                data['client_id']=props.clientId
            }
            if (mode_service) data['mode_service'] = props.modeService
        }
        
        let currentTicketCookie

        const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/ticket/construction/"+props.posid+"/"+idsLocalStorage[1]+"/"+idsLocalStorage[0], data
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                //Vérification si L'article est en stock négatif
                if(!Array.isArray(response.data.negative_stock)){
                    //On vérifie si negative_stock est un objet car si il n'y pas d'article en stock négatif, negative_stock est un []
                    let newarr = []

                    Object.keys(response.data.negative_stock).map(idArticle=>{
                        //ici on reconstruit "negativeAlreadyScan" si il y a un nouvel article en stock négatif
                        newarr.push(idArticle.toString())

                        //Si l'artile en stock négatif n'a pas encoré été scanné ou à deja été scannée mais son stock va passer en négatif, on affiche une alerte
                        if(!negativeAlreadyScan.includes(idArticle.toString())) swal.fire(t('stockNegativeAlertMsg'), "", "warning");
                    })

                    setNegativeAlreadyScan(newarr)
                }

                props.setCurrentTicket(response.data.data)
                currentTicketCookie=response.data.data.id
                if(!props.cookies.current_ticket){
                    props.setCookie("current_ticket",currentTicketCookie,{ path: "/", expires: props.expire_date }) 
                }
                
                let articleAfficheur
                if(articleid){
                    articleAfficheur = response.data.data.ticket_detail.find(value=>(value.article_id == articleid && !value.combo))
                }else{
                    articleAfficheur = response.data.data.ticket_detail.find(value=>{
                        if(value.article){
                            return (value.article.reference == valueInput && !value.combo)
                        }
                    })
                }
                
                if(props.peripheriqueParam && props.peripheriqueParam.afficheur && props.peripheriqueParam.afficheur.model=='aures_2_l'){
                    if(articleAfficheur) props.affichageClient(articleAfficheur.article.name,articleAfficheur.prix_remise,articleAfficheur.quantity,0,props.devise,t,props.peripheriqueParam)
                    //le 0 sur la variable 'raison' est passé pour définir que les infos ne concerne pas le total
                }
            }
            setLoadingSearchItem(false)
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setLoadingSearchItem(false)
        setValueInput('')
        setDisabled(false)
        props.setRelanceFocus(Date.now())
        props.setDisabledCloudButton(false)
    }

    const getNextShorcut = useGetNextShortcut({
        setDataNextShortcut: props.setDataNextShortcut,
        setDisabled,
        posid: props.posid,
        onSuccess: () => { if (showModalEdit) onCloseModalRppsl() },
    })

    const { colorStack, raccourciAction, getPreviousSearchRaccourci, resetSearchRaccourci, fullCustomCurrentParentUid } = useShortcutNavigation({
        getNextShorcut,
        allRaccourci,
        dataNextShortcut: props.dataNextShortcut,
        setDataNextShortcut: props.setDataNextShortcut,
        nextShortcutString: props.nextShortcutString,
        setNextShortcutString: props.setNextShortcutString,
        lastShortCutClicked: props.lastShortCutClicked,
        setLastShortCutClicked: props.setLastShortCutClicked,
        setDisabled,
        onArticleClick: (articleId) => {
            handleSubmitCheckSupplement(false, articleId);
            setDisabled(true);
        },
        onGiftcardClick: () => props.setShowModalGiftCard(true),
    })

    const toggleAlertSearchItem = () => {
        setGeneralErrorSearchItem(false)
    }

    // Fermeture modal supplément liste
    const onCloseModal = () => {
        setShowModal(false)
        setDataNextList([])
        setLastListClicked([])
        setEditArticleId(false)
        setDisabled(false)
    }

    // Validation des sélections faites dans la modale pour ajout au ticket
    const validModal = async (articleid, selectedSupplement, selectionPath) => {
        let data = {
            parent_supplement_id:articleid,
            article_supplement:selectedSupplement
        }
        
        if(props.cookies.current_ticket){
            data['id']=props.cookies.current_ticket
        }else{
            if(props.cashierId){
                data['rh_id']=props.cashierId
            }
            if(props.clientId){
                data['client_id']=props.clientId
            }
            if (mode_service) data['mode_service'] = props.modeService
        }
        
        let currentTicketCookie

        const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/ticket/construction/"+props.posid+"/"+idsLocalStorage[1]+"/"+idsLocalStorage[0], data
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                props.setCurrentTicket(response.data.data)
                currentTicketCookie=response.data.data.id
                if(!props.cookies.current_ticket){
                    props.setCookie("current_ticket",currentTicketCookie,{ path: "/", expires: props.expire_date }) 
                }
                
                let articleAfficheur
                if(articleid){
                    articleAfficheur = response.data.data.ticket_detail.sort((a,b) => b.id - a.id).find(value=> value.article_id == articleid)
                }else{
                    articleAfficheur = response.data.data.ticket_detail.sort((a,b) => b.id - a.id).find(value=>{
                        if(value.article){
                            return value.article.reference == valueInput
                        }
                    })
                }
                
                if(props.peripheriqueParam && props.peripheriqueParam.afficheur && props.peripheriqueParam.afficheur.model=='aures_2_l'){
                    if(articleAfficheur) props.affichageClient(articleAfficheur.article.name,(articleAfficheur.combo) ? articleAfficheur.prix_combo : articleAfficheur.prix_remise,articleAfficheur.quantity,0,props.devise,t,props.peripheriqueParam)
                    //le 0 sur la variable 'raison' est passé pour définir que les infos ne concerne pas le total
                }
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        onCloseModal()
    }

    // Fermeture modal RPPSL
    const onCloseModalRppsl = () => {
        setShowModalEdit(false)
        setRpValue(0);
        setPslValue(0);
        setRppslId(0);
        setRppsl([]);
        setValidButton(false)
    }

    // Fermeture modal ajout To
    const onCloseModalTo = () => {
        setShowModalAddTo(false)
        setArticleIdModal(false)
    }

    return(<>
        <Modal size="xl" show={showModal} onHide={() => onCloseModal()}>
            <Modal.Header closeButton>
                <Modal.Title>{t('supplementList')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ModalSelectionSupplementList
                    key={(!showModal) ? `modal-closed` : `modal-${showModal}`}
                    articleId={showModal}
                    editArticleId={editArticleId}
                    setEditArticleId={setEditArticleId}

                    // Pour affichage des listes suivantes
                    dataNextList={dataNextList}
                    setDataNextList={setDataNextList}
                    // Pour affichage des listes précédentes
                    lastListClicked={lastListClicked}
                    setLastListClicked={setLastListClicked}
                    from={'pos'}
                    validModal={validModal}
                />
            </Modal.Body>
        </Modal>
        <Modal size='sm' show={showModalEdit} onHide={() => onCloseModalRppsl()}>
            <Modal.Header closeButton>
                <Modal.Title>{t('rppslEdit')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {showModalEdit &&
                    <RppslModalEdit 
                        rppsl={rppsl} 
                        section={props.section} 
                        articleIdModal={articleIdModal} 
                        rpValue={rpValue} 
                        setRpValue={setRpValue} 
                        pslValue={pslValue} 
                        setPslValue={setPslValue} 
                        rppslId={rppslId} 
                        sectionId={props.section.id} 
                        validButton={validButton}
                        setValidButton={setValidButton}
                        from='pos'
                        getNextShorcut={getNextShorcut}
                        lastShortCutClicked={props.lastShortCutClicked}
                        nextShortcutString={props.nextShortcutString}
                    />
                }
            </Modal.Body>
        </Modal>
        <Modal size='sm' show={showModalAddTo} onHide={() => onCloseModalTo()}>
            <Modal.Header closeButton>
                <Modal.Title>{t('insertToRecords')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {showModalAddTo &&
                    <ModalAddTo 
                        section={props.section} 
                        articleIdModal={articleIdModal} 
                        articleNameModal={articleNameModal} 
                        articleSkuModal={articleSkuModal}
                        setShowModalAddTo={setShowModalAddTo}
                        to={props.to}
                        setTo={props.setTo}
                    />
                }
            </Modal.Body>
        </Modal>
        <ArticleBarSearch
            loadingSearchItem={loadingSearchItem}
            loadItems={loadItems}
            listSearchItem={listSearchItem}
            datas={datas}
            setDatas={setDatas}
            dataNextShortcut={props.dataNextShortcut}
            lastShortCutClicked={props.lastShortCutClicked}
            resetSearchRaccourci={resetSearchRaccourci}
            getPreviousSearchRaccourci={getPreviousSearchRaccourci}
            valueInput={valueInput}
            setValueInput={setValueInput}
            handleSubmit={handleSubmitCheckSupplement}
            setRelanceFocus={props.setRelanceFocus}
            searchInput={searchInput}
            noBlur={false}
            disabled={disabled}
        />
        <div className={`col-12 ${props.view}`}>
            <div className="raccourciConfigGrid" style={{gridTemplateColumns:`repeat(${props.section?.profil_raccourci_caisse?.nbr_cellule || 3}, 1fr)`}}>
                {(props.dataNextShortcut.length!=0 || (props.lastShortCutClicked[0]==='fullCustom' && !disabled)) ?
                    <>
                        {fullCustomCurrentParentUid
                            // Navigation dans un fullCustom — filtrage frontend par from_uid
                            ? props.dataNextShortcut
                                .filter(c => c.from_uid === fullCustomCurrentParentUid)
                                .sort((a, b) => (a.position ?? 999) - (b.position ?? 999))
                                .map((item, idx) => {
                                    const isArticleEntry = !!item.article_id
                                    const raccourciType = isArticleEntry ? 'article' : 'fullCustom'
                                    const tileTitle = isArticleEntry ? item.article_name : item.fulcustom_name
                                    const raccourciTypeId = isArticleEntry ? item.article_id : item.uid
                                    return (
                                        <Raccourci
                                            key={`${raccourciTypeId}-${idx}`}
                                            title={tileTitle}
                                            image={item.article_image}
                                            raccourciType={raccourciType}
                                            raccourciAction={raccourciAction}
                                            raccourciTypeId={raccourciTypeId}
                                            setRelanceFocus={props.setRelanceFocus}
                                            disabled={disabled}
                                            color={item.color || colorStack[0] || false}
                                        />
                                    )
                                })
                            // Navigation standard
                            : props.dataNextShortcut.map((item, idx)=>(
                                <Raccourci
                                    key={`${item.id}-${idx}`}
                                    title={item.affiche}
                                    image={item.image}
                                    raccourciType={item.type}
                                    raccourciAction={raccourciAction}
                                    raccourciTypeId={item.type === 'fromCustomField' ? idx : item.id}
                                    setRelanceFocus={props.setRelanceFocus}
                                    disabled={disabled}
                                    stockArticle={(item.hasOwnProperty('stock')) ? item.stock.toString() : false}
                                    stockDock={(item.hasOwnProperty('stock_dock')) ? item.stock_dock.toString() : false}
                                    rppsl={(item.hasOwnProperty('rppsl')) ? item.rppsl : false}
                                    rppslVal={rppsl}
                                    setRppsl={setRppsl}
                                    modulePos={modulePos}
                                    showModalEdit={showModalEdit}
                                    setShowModalEdit={setShowModalEdit}
                                    articleIdModal={articleIdModal}
                                    setArticleIdModal={setArticleIdModal}
                                    setRppslId={setRppslId}
                                    setRpValue={setRpValue}
                                    setPslValue={setPslValue}
                                    showModalAddTo={showModalAddTo}
                                    setShowModalAddTo={setShowModalAddTo}
                                    setArticleNameModal={setArticleNameModal}
                                    sku={item.sku}
                                    articleSkuModal={articleSkuModal}
                                    setArticleSkuModal={setArticleSkuModal}
                                    color={item.color || colorStack[0] || false}
                                />
                            ))
                        }
                    </>
                :
                    <>
                        {(allRaccourci.length!=0) ?
                            allRaccourci.map(value=>{
                                let raccourciType
                                for(let i=0; i<raccourciArr.length; i++){
                                    if(value[raccourciArr[i]]!=null){
                                        raccourciType=raccourciArr[i].replace('_id', '')
                                    }
                                }
                                if (!raccourciType) raccourciType = value.type

                                const isFullCustom = raccourciType === 'fullCustom'
                                const tileTitle = isFullCustom ? value.construction?.[0]?.fulcustom_name : value.affiche
                                const tileColor = isFullCustom ? value.construction?.[0]?.color : (value.color || false)

                                return(
                                    <Raccourci
                                        key={value.id}
                                        title={tileTitle}
                                        image={value.image}
                                        raccourciType={raccourciType}
                                        raccourciAction={raccourciAction}
                                        raccourciTypeId={value[raccourciType+'_id'] ?? value.id}
                                        setRelanceFocus={props.setRelanceFocus}
                                        disabled={disabled}
                                        stockArticle={(value.hasOwnProperty('stock')) ? value.stock.toString() : false}
                                        modulePos={modulePos}
                                        color={tileColor}
                                    />
                                )
                            })
                        :
                            false
                        }
                        {custom_made_article &&
                            <CustomMadeItemBtn 
                                setRelanceFocus={props.setRelanceFocus}
                                disabled={disabled}
                                cookies={props.cookies}
                                setCookie={props.setCookie}
                                clientId={props.clientId}
                                cashierId={props.cashierId}
                                posid={props.posid}
                                currentTicket={props.currentTicket}
                                setCurrentTicket={props.setCurrentTicket}
                                expire_date={props.expire_date}
                                peripheriqueParam={props.peripheriqueParam}
                                affichageClient={props.affichageClient}
                            />
                        }
                        {(modulePos.params.gift_card.active) &&
                            <Raccourci 
                                title={t('giftcard')} 
                                raccourciType='giftcard'
                                raccourciAction={raccourciAction}
                                setRelanceFocus={props.setRelanceFocus}
                                disabled={disabled}
                            />
                        }
                    </>
                }
            </div>
        </div>
        {(generalErrorSearchItem) &&
            <SweetAlert show="true" title={t('unknowError')} type="error" onConfirm={() => toggleAlertSearchItem()}/>
        }
    </>
    )
}

export default BarRight;